import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import AdminLayout from './components/Layout/AdminLayout';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Messages from './pages/Messages';
import Products from './pages/Products';
import Orders from './pages/Orders';
import Categories from './pages/Categories';
import Transactions from './pages/Transactions';
import Users from './pages/Users';
import CompanyInfo from './pages/CompanyInfo';
import Pages from './pages/Pages';
import NavigationEditor from './pages/NavigationEditor';
import PickupPoints from './pages/PickupPoints';
import DeliveryZones from './pages/DeliveryZones';
import Coupons from './pages/Coupons';
import PreOrders from './pages/PreOrders';
import QRCodeGenerator from './pages/QRCodeGenerator';
import Formulas from './pages/Formulas';
import LoisirProducts from './pages/LoisirProducts';
import Workshops from './pages/Workshops';
import WorkshopCategories from './pages/WorkshopCategories';
import WorkshopReservations from './pages/WorkshopReservations';
import ProductSales from './pages/ProductSales';
import SaleCategories from './pages/SaleCategories';
import GeneralSettings from './pages/GeneralSettings';
import WorkshopPageContent from './pages/WorkshopPageContent';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <Routes>
                  <Route path="/messages" element={<Messages />} />
                  <Route path="/orders" element={<Orders />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/product-sales" element={<ProductSales />} />
                  <Route path="/sale-categories" element={<SaleCategories />} />
                  <Route path="/general-settings" element={<GeneralSettings />} />
                  <Route path="/workshop-page" element={<WorkshopPageContent />} />
                  <Route path="/categories" element={<Categories />} />
                  <Route path="/transactions" element={<Transactions />} />
                  <Route path="/company-info" element={<CompanyInfo />} />
                  <Route path="/users" element={<Users />} />
                  <Route path="/pages" element={<Pages />} />
                  <Route path="/navigation-editor" element={<NavigationEditor />} />
                  <Route path="/pickup-points" element={<PickupPoints />} />
                  <Route path="/delivery-zones" element={<DeliveryZones />} />
                  <Route path="/coupons" element={<Coupons />} />
                  <Route path="/pre-orders" element={<PreOrders />} />
                  <Route path="/formulas" element={<Formulas />} />
                  <Route path="/loisir-products" element={<LoisirProducts />} />
                  <Route path="/workshops" element={<Workshops />} />
                  <Route path="/workshop-categories" element={<WorkshopCategories />} />
                  <Route path="/workshop-reservations" element={<WorkshopReservations />} />
                  <Route path="/" element={<Navigate to="/pages" replace />} />
                  <Route path="/qr-generator" element={<QRCodeGenerator />} />
                </Routes>
              </AdminLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;